// extracted by css-extract-rspack-plugin
export default {"container":"container-CmjwQV","title":"title-ElQNg6","titleStart":"titleStart-uGI3Vl","titleText":"titleText-XTiu7x","actions":"actions-F6DsXq","content":"content-f9Duqn"};